var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGauge = function SvgIconGauge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.705 19H21a1.75 1.75 0 0 0 1.75-1.75V15c0-.91-.116-1.816-.343-2.694a1 1 0 0 0-.046-.171A10.75 10.75 0 0 0 11.96 4.25c-4.867.017-8.942 3.307-10.26 7.752a1 1 0 0 0-.12.438 11 11 0 0 0-.329 2.663v2.147A1.75 1.75 0 0 0 3 19h6.705m5.62-12.094A8.8 8.8 0 0 0 13 6.307V8.25a1 1 0 1 1-2 0V6.307c-3.235.374-5.935 2.544-7.114 5.486l1.857.497a1 1 0 1 1-.517 1.932l-1.87-.5q-.105.676-.106 1.381V17H9.2l6.113-7.962a1 1 0 0 1 1.586 1.218L11.722 17h9.028v-2q0-.646-.094-1.281l-1.882.503a1 1 0 1 1-.517-1.932l1.882-.503-.058-.143a8.75 8.75 0 0 0-4.756-4.738",
    clipRule: "evenodd"
  })));
};
export default SvgIconGauge;